import styled from 'styled-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Nav = styled.nav`
  background: rgba(10, 25, 47, 0.7);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-color);
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.h1`
  color: var(--primary-color);
  font-size: 1.5rem;
  font-weight: bold;
  text-shadow: 0 0 10px var(--primary-glow);
`;

const NavLinks = styled.div<{ isOpen: boolean }>`
  display: flex;
  gap: 2rem;
  align-items: center;
  
  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(20px);
    padding: 1rem;
    gap: 1rem;
  }

  a {
    display: flex;
    align-items: center;
    height: 38px;
    padding: 0 0.5rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    
    &:hover {
      background: var(--surface-color);
      border-color: var(--primary-color);
    }
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.5rem;
  text-shadow: 0 0 10px var(--primary-glow);
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Nav>
      <NavContent>
        <Logo>{t('company.name')}</Logo>
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? '✕' : '☰'}
        </MenuButton>
        <NavLinks isOpen={isMenuOpen}>
          <NavItem>
            <a href="#products">{t('nav.products')}</a>
          </NavItem>
          <NavItem>
            <a href="#about">{t('nav.about')}</a>
          </NavItem>
          <NavItem>
            <a href="#contact">{t('nav.contact')}</a>
          </NavItem>
          <NavItem>
            <LanguageSwitcher />
          </NavItem>
        </NavLinks>
      </NavContent>
    </Nav>
  );
} 